import React from 'react';
import PropTypes from 'prop-types';

import FullBackgroundImage from '../../layouts/FullBackgroundImage';
import Middle from '../../../common/layouts/Middle';
import Paper from '../../../common/components/Paper';
import AuthFlow from '../../layouts/AuthFlow';

const CredentialBoxWrapper = ({ children }) => (
  <FullBackgroundImage>
    <Middle>
      <Paper>
        <AuthFlow>{children}</AuthFlow>
      </Paper>
    </Middle>
  </FullBackgroundImage>
);

CredentialBoxWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default CredentialBoxWrapper;



// WEBPACK FOOTER //
// ./src/views/officials-connect/layouts/CredentialBoxWrapper/index.jsx